"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uiKit = require("@devsta/ui-kit");

var _clientAuth = require("@devsta/client-auth");

var _getUserFullName = _interopRequireDefault(require("@devsta/get-user-full-name"));

var _formatRoleName = _interopRequireDefault(require("../../../../../../../common/utils/formatRoleName"));

require("../styles/_users-list.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function UsersListItem(_ref) {
  var membership = _ref.membership,
      organisationRoles = _ref.organisationRoles,
      actionOptions = _ref.actionOptions,
      updateMembershipRole = _ref.updateMembershipRole,
      hasManagePermission = _ref.hasManagePermission;
  var userEmail = membership.userEmail,
      status = membership.status,
      user = membership.user,
      role = membership.role;

  var _ref2 = user || {},
      imageUrl = _ref2.imageUrl,
      jobTitle = _ref2.jobTitle,
      videoCount = _ref2.videoCount,
      userId = _ref2.userId,
      initialSetup = _ref2.initialSetup;

  var isAccepted = status === 'ACCEPTED';
  var userTitle = initialSetup ? (0, _getUserFullName.default)(user) : userEmail;
  var roleOptions = organisationRoles.map(function (_ref3) {
    var roleId = _ref3.roleId,
        name = _ref3.name;
    return {
      value: roleId,
      label: (0, _formatRoleName.default)(name)
    };
  });
  var memberRole = roleOptions.find(function (_ref4) {
    var value = _ref4.value;
    return role && role.roleId === value;
  });

  var userCredentials = _clientAuth.credentials.get();

  return /*#__PURE__*/_react.default.createElement(_uiKit.List.ListItem, {
    hideImage: true
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Image, {
    imageUrl: imageUrl,
    placeholderText: userTitle,
    placeholderTextSize: 30,
    width: "90px",
    height: "90px",
    defaultImageIcon: "user-profile-sq",
    rounded: true
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "users-list__item__details"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('users-list__item__details__name')
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    heading5: true,
    ellipsisOverflow: true,
    noMargin: true
  }, userTitle, userCredentials.user && userCredentials.user.userId === userId ? ' (you)' : '')), isAccepted && jobTitle && /*#__PURE__*/_react.default.createElement("div", {
    className: "users-list__item__details__job-title"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    ellipsisOverflow: true,
    noMargin: true
  }, jobTitle)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('users-list__item__details__status', {
      'users-list__item__details__status__active': isAccepted
    })
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    label: true,
    ellipsisOverflow: true,
    noMargin: true,
    success: isAccepted,
    warning: !isAccepted
  }, isAccepted ? 'Active' : 'Invite Pending'))), /*#__PURE__*/_react.default.createElement("div", {
    className: "users-list__item__details__user-email"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    ellipsisOverflow: true
  }, userEmail)), /*#__PURE__*/_react.default.createElement("div", {
    className: "users-list__item__videos"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "users-list__item__videos__info"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    prefixIcon: "video"
  }, videoCount || '0', ' ', videoCount === 1 ? 'Video' : 'Videos'))), /*#__PURE__*/_react.default.createElement(_uiKit.Dropdown, {
    className: "users-list__item__role",
    placeholder: "Select Role",
    options: roleOptions,
    onChange: updateMembershipRole,
    value: memberRole,
    disabled: !isAccepted || !hasManagePermission,
    type: "BUTTON"
  }), /*#__PURE__*/_react.default.createElement(_uiKit.ActionPopup, {
    options: actionOptions
  }));
}

var _default = (0, _react.memo)(UsersListItem);

exports.default = _default;